import { Col } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'
import type { CSSVariableBreakpointToken } from '@repo/ui/types'

interface IDashboardLayoutProps {
  children: React.ReactNode
  footer?: React.ReactNode
  header?: React.ReactNode
  sidebar?: React.ReactNode
  subHeader?: React.ReactNode
  screenMaxWidth?: CSSVariableBreakpointToken
  asideMaxWidth?: CSSVariableBreakpointToken
  mainClassName?: string
}

export const DashboardReverseLayout = (props: IDashboardLayoutProps) => {
  const {
    children,
    footer,
    header,
    sidebar,
    subHeader,
    screenMaxWidth = 'md',
    asideMaxWidth = '4xs',
    mainClassName = 'bg-neutral-surface',
  } = props
  const screenMaxWidthClass = (
    {
      '5xs': 'max-w-screen-5xs',
      '4xs': 'max-w-screen-4xs',
      '3xs': 'max-w-screen-3xs',
      '2xs': 'max-w-screen-2xs',
      xs: 'max-w-screen-xs',
      sm: 'max-w-screen-sm',
      md: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      full: 'max-w-screen-full',
    } satisfies Record<CSSVariableBreakpointToken, string>
  )[screenMaxWidth]
  const asideMaxWidthClass = (
    {
      '5xs': 'md:max-w-screen-5xs',
      '4xs': 'md:max-w-screen-4xs',
      '3xs': 'md:max-w-screen-3xs',
      '2xs': 'md:max-w-screen-2xs',
      xs: 'md:max-w-screen-xs',
      sm: 'md:max-w-screen-sm',
      md: 'md:max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      full: 'max-w-screen-full',
    } satisfies Record<CSSVariableBreakpointToken, string>
  )[asideMaxWidth]
  return (
    <Col
      className={cn(
        'min-h-screen relative',
        'bg-neutral-surface-light',
        mainClassName,
      )}
    >
      {header && (
        <header
          className={cn('sticky top-0 w-full z-20', 'bg-neutral-surface-light')}
        >
          {header}
        </header>
      )}
      {subHeader && (
        <div
          className={`flex w-full ${screenMaxWidthClass} mx-auto gap-md my-md px-md`}
        >
          {subHeader}
        </div>
      )}
      <div
        className={`flex flex-col md:flex-row w-full flex-1 ${screenMaxWidthClass} mx-auto gap-md px-md md:px-0 py-md`}
      >
        <main className='flex-1 w-full md:p-0'>{children}</main>
        {sidebar && (
          <aside
            className={`w-full ${asideMaxWidthClass} px-md py-md md:py-0  md:sticky md:top-7xl md:bottom-0 md:self-start `}
          >
            {sidebar}
          </aside>
        )}
      </div>

      {footer && <footer>{footer}</footer>}
    </Col>
  )
}
